import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
const t = (k, a) => app.translator.trans('ernestdefoe-ai-helper.forum.' + k, a);
const icon = function (name, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  return Icon.component(_objectSpread({
    name
  }, attrs));
};

/** "Summarize this thread" — a polished modal around the AI summarize endpoint. */
export default class SummaryModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "summary", '');
    _defineProperty(this, "model", '');
    _defineProperty(this, "error", '');
    _defineProperty(this, "copied", false);
  }
  className() {
    return 'AiSummaryModal Modal--medium';
  }
  title() {
    return m('span.AiSummaryModal-title', [icon('fas fa-wand-magic-sparkles', {
      className: 'AiSummaryModal-titleIcon'
    }), t('summary_title')]);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  load() {
    this.loading = true;
    this.error = '';
    this.copied = false;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ai-helper/summarize',
      body: {
        data: {
          attributes: {
            discussionId: this.attrs.discussion.id()
          }
        }
      }
    }).then(r => {
      this.summary = r.summary || '';
      this.model = r.model || '';
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.error = t('summary_error');
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    return m('.Modal-body.AiSummaryModal-body', this.loading ? this.loadingView() : this.error ? this.errorView() : this.summaryView());
  }
  loadingView() {
    return m('.AiSummary-loading', [m('.AiSummary-orb', icon('fas fa-robot')), m('.AiSummary-loadingText', t('summary_loading')), m('.AiSummary-skeleton', [m('span'), m('span'), m('span')])]);
  }
  errorView() {
    return m('.AiSummary-state.AiSummary-state--error', [m('.AiSummary-stateIcon', icon('fas fa-triangle-exclamation')), m('p', this.error), Button.component({
      className: 'Button',
      icon: 'fas fa-rotate-right',
      onclick: () => this.load()
    }, t('summary_retry'))]);
  }
  summaryView() {
    return [m('.AiSummary', this.renderBody(this.summary)), m('.AiSummary-foot', [m('span.AiSummary-badge', [icon('fas fa-robot'), t('summary_ai_note')]), m('.AiSummary-actions', [Button.component({
      className: 'Button Button--link AiSummary-actionBtn',
      icon: this.copied ? 'fas fa-check' : 'far fa-copy',
      onclick: () => this.copy()
    }, this.copied ? t('summary_copied') : t('summary_copy')), Button.component({
      className: 'Button Button--link AiSummary-actionBtn',
      icon: 'fas fa-rotate-right',
      onclick: () => this.load()
    }, t('summary_regenerate'))])]), this.model ? m('.AiSummary-model', t('summary_model', {
      model: this.model
    })) : null];
  }
  copy() {
    try {
      navigator.clipboard.writeText(this.summary).then(() => {
        this.copied = true;
        m.redraw();
        setTimeout(() => {
          this.copied = false;
          m.redraw();
        }, 2000);
      });
    } catch (e) {
      // clipboard unavailable — no-op
    }
  }

  /** Minimal, XSS-safe Markdown → vnodes: headings, bullet/numbered lists, paragraphs. */
  renderBody(text) {
    const lines = text.replace(/\r/g, '').split('\n');
    const out = [];
    let i = 0;
    const isBullet = l => /^\s*[-*•]\s+/.test(l);
    const isNumber = l => /^\s*\d+[.)]\s+/.test(l);
    while (i < lines.length) {
      const line = lines[i];
      if (!line.trim()) {
        i++;
        continue;
      }
      if (isBullet(line)) {
        const items = [];
        while (i < lines.length && isBullet(lines[i])) items.push(m('li', this.inline(lines[i++].replace(/^\s*[-*•]\s+/, ''))));
        out.push(m('ul.AiSummary-list', items));
        continue;
      }
      if (isNumber(line)) {
        const items = [];
        while (i < lines.length && isNumber(lines[i])) items.push(m('li', this.inline(lines[i++].replace(/^\s*\d+[.)]\s+/, ''))));
        out.push(m('ol.AiSummary-list', items));
        continue;
      }
      const heading = line.match(/^\s*#{1,6}\s+(.*)$/);
      if (heading) {
        out.push(m('p.AiSummary-h', this.inline(heading[1])));
        i++;
        continue;
      }

      // Paragraph: gather consecutive plain lines.
      const para = [];
      while (i < lines.length && lines[i].trim() && !isBullet(lines[i]) && !isNumber(lines[i]) && !/^\s*#{1,6}\s+/.test(lines[i])) {
        para.push(lines[i++]);
      }
      out.push(m('p', this.inline(para.join(' '))));
    }
    return out;
  }

  /** Inline Markdown: **bold**, *italic*, `code`. */
  inline(s) {
    return s.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g).filter(Boolean).map(p => {
      if (/^\*\*[^*]+\*\*$/.test(p)) return m('strong', p.slice(2, -2));
      if (/^\*[^*]+\*$/.test(p)) return m('em', p.slice(1, -1));
      if (/^`[^`]+`$/.test(p)) return m('code', p.slice(1, -1));
      return p;
    });
  }
}
flarum.reg.add('ernestdefoe-ai-helper', 'forum/components/SummaryModal', SummaryModal);